import React from 'react'
import {CollapsablePanel} from '../../collapsable-panel'
import {useBasketStore} from '../../../store/hooks/useStore'
import {Box, Flex, Text} from '../../../vanilla'
import {ChevronDownIcon, DeliverySmallIcon, ExclamationTriangleIcon} from '../../icons'
import {ReservationDetails} from './mobile-navigation-booking/reservation-details'
import {ReservationExpiredSlot} from './mobile-navigation-booking/reservation-expired-slot'
import {observer} from 'mobx-react'
import DeliveryInitial from './mobile-navigation-booking/delivery-initial'
import { useSlotExpiration } from '../../../store/hooks/useSlotExpiration'
import { MobileNavigationLoggedLinksProps } from './mobile-navigation-logged-links'
import { DeliveryTimeAndDate } from '../../book-delivery/delivery-time-and-date'

export const DeliverySlot = observer(({onClose}: MobileNavigationLoggedLinksProps) => {
  const {basket, currentDeliverySlotId, slotTime} =
    useBasketStore()
  const {isReservationExpired} = useSlotExpiration()

  return (
    <>
      <CollapsablePanel
        width="full"
        defaultOpen={true}
        mHeight='fit'
        panelContent={
          <Box
            paddingX="12px"
            paddingY="8px"
            bg="white"
            style={{borderBottom: '1px solid #d8d8d8'}}
          >
            {currentDeliverySlotId ? (
              !isReservationExpired() ? (
                <ReservationDetails onClose={onClose}/>
              ) : (
                <ReservationExpiredSlot onClose={onClose}/>
              )
            ) : (
              <DeliveryInitial onClose={onClose}/>
            )}
          </Box>
        }
      >
        {({isOpen, onToggle}) => (
          <Flex
            onClick={() => onToggle()}
            justify="space-between"
            align="center"
            borderTop="1px"
            borderColor="gray200"
            borderBottom="1px"
            bg="white"
            position="relative"
            paddingRight="12px"
          >
            {isReservationExpired() && (
              <ExclamationTriangleIcon
                color="accent0"
                position="absolute"
                height="16px"
                width="16px"
                style={{top: '12px', left: '12px'}}
                zIndex="docked"
              />
            )}
            <Flex paddingY="16px" gap="8px" paddingLeft="28px" paddingRight="20px">
              <DeliverySmallIcon color="accent3" height="24px" width="auto" />
              {currentDeliverySlotId ? (
                <Box>
                  <Text style={{fontSize: '12px', fontWeight: 'bold', lineHeight: '14px'}}>
                    Your Delivery
                  </Text>
                  <DeliveryTimeAndDate
                    startHour={slotTime(basket?.c_windowStartTime)}
                    endHour={slotTime(basket?.c_windowEndTime)}
                    textProps={{fontSize: 'xs', lineHeight: 'shorter'}}
                  />
                </Box>
              ) : (
                <Text variant="text4" textDecoration="none" data-test-selector="book-delivery-mobile-toggle">
                  Book a Delivery
                </Text>
              )}
            </Flex>
            <ChevronDownIcon
              style={{transform: isOpen ? 'rotate(180deg)' : 'unset'}}
              width="16px"
              height="auto"
            />
          </Flex>
        )}
      </CollapsablePanel>
    </>
  )
})
